<template>
  <div class="agree-wrapper"
       @click.self="close">
    <div class="agree">
      <div class="title">《用户服务协议》及隐私政策</div>
      <div class="content">
        <p>
      雷石手机点歌平台（又称“本软件”）及相关服务，系由北京雷石天地电子技术股份有限公司及其关联方（下称“公司”或“我们”）开发、运营的，标注名称为“手机点歌平台”的客户端应用程序（同时含其简化版等不同版本）向您提供平台服务的一款卡拉OK设备点歌软件。《雷石手机点歌平台用户服务协议》是您（又称“用户”）与公司之间的关于您注册、登录、使用（以下又统称“使用”）本软件及服务所订立的协议。
    </p>
    <p>
     为了更好地为您提供服务，请您在开始使用“雷石手机点歌平台”软件及相关服务之前，认真阅读并充分理解本协议，特别是涉及免除或者限制责任的条款、权利许可和信息使用的条款、同意开通和使用特殊单项服务的条款、法律适用和争议解决条款等。其中，免除或者限制责任条款等重要内容将以加粗形式提示您注意，您应重点阅读。如您自主选择同意或使用雷石手机点歌平台软件及相关服务，或者以其他任何明示或者默示方式表示接受本协议的，均即视为您已充分理解本协议，并同意作为本协议的一方当事人自愿签署本协议，自愿接受本协议以及其他与雷石手机点歌平台软件及服务相关的协议和规则（包括但不限于《隐私保护政策》、支付规则）全部条款的约束，本协议将构成您与我们及我们经营的雷石手机点歌平台软件之间具有约束力的法律文件。如果某一特定业务或服务有单独的服务协议、规则、指引，您在遵守本协议的同时，也应遵守该单独的服务协议、规则和指引。
    </p>
    <p>在您接受本协议之后，本协议文本可能因国家政策、法律、产品、技术、服务及本协议履约环境发生变化等原因而进行修订，修订内容构成本协议的组成部分。本协议更新后，我们会通过适当的方式提醒您更新的内容，以便您及时了解本协议的最新版本，您也可以于软件设置页面查阅最新版本的协议条款。如您继续使用雷石手机点歌平台软件及相关服务，即表示您已同意接受修订后的本协议内容。若您对修改后的协议有异议的，请立即停止登录、使用雷石手机点歌平台软件和服务，您的继续登录或使用的行为，即表示您已认可和接受修订后的协议。</p>
    <p>我们有权依“雷石手机点歌平台”软件及相关服务或运营的需要单方决定，安排或指定关联方、控制公司、继承公司或公司认可的第三方公司继续运营“雷石手机点歌平台”软件。并且，就本协议项下涉及的某些服务，可能会由公司的关联方、控制公司、继承公司或公司认可的第三方公司向您提供。您知晓并同意接受相关服务内容，即视为接受相关权利义务关系亦受本协议约束。</p>
    <h2 class="sub-title">
      一、软件服务及使用
    </h2>
    <p>
      我们通过雷石手机点歌平台软件向用户提供丰富的互联网服务。
    </p>
    <p style="font-weight: bolder;">
      如您要登录和使用本软件，需要注册成为本软件的用户，用户使用的雷石手机点歌平台是雷石公司确认用户身份的唯一依据，用户应维持账号及密码的机密安全并，对该账号进行的所有活动和行为负责，禁止赠与、借用、租用、转让或售卖账号。注册时请您认真阅读并理解本协议，如您继续注册并登录、使用本软件，均即视为您已充分理解本协议，并同意作为本协议的一方当事人自愿签署本协议，受本协议约束。
    </p>
    <p style="font-weight: bolder;">
      用户不得恶意注册账号（包括但不限于频繁注册、批量注册、使用他人身份注册、恶意利用或破坏雷石系统注册账号等）任何通过非官方途径获得的账号（包括但不限于购买、借用、租用、分享等方式获得的账号）或恶意注册获得的账号，雷石公司有权进行封禁、注销、或收回，如发生任何损失，用户自行承担。
    </p>
    <p>
      我们许可您一项个人的、可撤销的、不可转让的、非独占地和非商业的合法使用“雷石手机点歌平台”软件及相关服务的权利。本协议未明示授权的其他一切权利仍由公司保留，您在行使该权利前须另行获得公司的书面许可，同时公司如未行使前述任何权利，并不构成对该权利的放弃。
    </p>
    <p>
      您理解并承诺，您所设置的帐号不得违反国家法律法规及“雷石手机点歌平台”的相关规则，您的帐号名称、头像和简介等注册信息及其他个人信息中不得出现违法和不良信息，未经他人许可不得用他人名义（包括但不限于冒用他人姓名、名称、字号、头像等或采取其他足以让人引起混淆的方式）开设帐号，不得恶意注册“雷石手机点歌平台”帐号（包括但不限于频繁注册、批量注册帐号等行为）。您在帐号注册及使用过程中需遵守相关法律法规，不得实施任何侵害国家利益、损害其他公民合法权益，有害社会道德风尚的行为。我们有权对您提交的注册信息进行审核。
    </p>
    <p>
      您理解，您在完成申请注册手续后，仅获得雷石手机点歌平台帐户的使用权，且该使用权仅限于您本人，即账号初始注册人拥有。同时，未经公司书面同意，账号初始注册人禁止以任何形式赠与、借用、出租、转让、售卖雷石手机点歌平台账号或者以其他方式许可他人使用该账号。非账号初始注册人不得通过受赠、继承、承租、受让或者其他任何方式获取、使用雷石手机点歌平台账号。如果雷石手机点歌平台发现或者有合理理由认为使用者并非账号初始注册人，为保障帐号安全，我们有权立即暂停或终止向该注册帐号提供服务，并有权永久禁用该帐号。有权在未经通知的情况下回收该账号而无需向该账号使用人承担法律责任，由此带来的包括并不限于用户通讯中断、用户资料和道具等清空等损失由用户自行承担。您有义务妥善保管在注册并使用雷石点歌平台时获得的个人帐号、密码
的安全性与保密性，并对您以注册帐号名义所从事的活动承担全部法律责任，包括但不限于您在“雷石手机点歌平台”软件及相关服务上进行的任何数据修改、言论发表、款项支付等操作行为可能引起的一切法律责任。您应高度重视对帐号与密码的保密，在任何情况下不向他人透露帐号及密码信息。因您保管不当等自身原因或其他不可抗因素导致遭受盗号或密码丢失，您应自行承担相应责任。
    </p>
    <p>
      除自行注册“雷石手机点歌平台”帐号外，您也可选择通过授权使用您合法拥有的包括但不限于公司和/或其关联方其他软件或平台用户帐号，以及实名注册的第三方软件或平台用户帐号登录使用“雷石手机点歌平台”软件及相关服务，但第三方软件或平台对此有限制或禁止的除外。当您以前述已有帐号登录使用的，应保证相应帐号同样适用本协议中的相关条款。
    </p>
    <p>
      您理解并同意，除您登录、使用“雷石手机点歌平台”软件及相关服务外，您还可以用“雷石手机点歌平台”帐号登录使用公司及其关联方或其他合作方提供的其他软件、服务。您以“雷石手机点歌平台”帐号登录并使用前述服务的，同样应受其他软件、服务实际提供方的用户协议及其他协议条款约束。
    </p>
    <p style="font-weight: bolder;">
      用户理解并同意，若用户在注册和使用雷石账号时，存在任何违反法律法规或不符合本条款规定之行为，雷石公司有权不予注册，已经注册的，雷石公司有权不通知用户而单方采取限期改正、短期封禁、永久封禁、注销、收回账号等措施。
    </p>
    <p style="font-weight: bolder;">
      用户不得利用雷石软件或服务实施以下行为：（1）对雷石点歌平台进行反向工程、反向汇编、反向编译或以其他方式自雷石软件获取源代码等；（2）通过不正当手段或以违反诚实信用原则的方式（如利用规则漏洞、利用系统漏洞、滥用会员身份、黑色产业、投机等违背雷石公司提供服务的初衷的方式）使用雷石点歌软件和服务；（3）其他以任何不合法的方式、为任何不合法的目的、或以任何与本条款不一致的方式使用雷石软件和服务。
    </p>
    <p>
      为提高您作品、录音制品的曝光量及发布效率，您同意您在“雷石手机点歌平台”软件及相关服务的帐号及相应帐号所发布的全部内容均授权公司以您的帐号自动同步发布至手机点歌平台排行榜单、公司及/或关联方运营的其他软件及网站，您帐号的头像、昵称等公开信息可能会一并同步。您在“雷石手机点歌平台”软件/网站发布、修改、删除内容的操作，均会同步到上述其他软件及网站。您通过已注册或者已同步的帐号登录公司及/或关联方运营的系列客户端软件产品及网站时（如有），应遵守该软件产品及网站自身的用户协议及其他协议条款的规定。
    </p>
    <p>
      您理解，您使用“雷石手机点歌平台”软件及相关服务需自行准备与软件及相关服务有关的终端设备（如电脑、手机等装置），一旦您在您终端设备中打开“雷石手机点歌平台”软件或访问“雷石手机点歌平台”相关网站，即视为您使用“雷石手机点歌平台”软件及相关服务。为充分实现“雷石手机点歌平台”的全部功能，您可能需要将您的终端设备联网，您理解您应自行承担所需要的费用（如流量费、上网费等）。
    </p>
    <p>
      您应当自行约束您在雷石点歌平台上的用户行为，保证自己在线直播过程中的人身安全及财产安全。如您在雷石点歌平台网站外的场所或地域，因您自身原因、不可抗力或意外事件或第三方原因造成的人身及财产损失，由您自行承担。使用雷石点歌平台服务过程中，您需遵守以下法律法规：《中华人民共和国保守国家秘密法》、《中华人民共和国著作权法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》、《信息网络传播权保护条例》、《互联网直播服务管理规定》等有关计算机及互联网规定的法律、法规。在任何情况下，公司一旦合理地认为您的行为可能违反上述法律、法规，可以在任何时候，不经事先通知终止向您提供服务。
    </p>
    <h2 class="sub-title">
      二、隐私保护政策
    </h2>
    <p>
      我们与您一同致力于您个人信息（即能够独立或与其他信息结合后识别您身份的信息）的保护。
    </p>
    <p>
      保护用户个人信息是我们的基本原则之一，在使用“雷石手机点歌平台”软件及相关服务的过程中，您可能需要提供您的个人信息（包括但不限于您的姓名、电话号码、位置信息、设备信息等），以便我们向您提供更好的服务和相应的技术支持。我们可能会根据推荐算法，向您个性化推荐内容，我们不断完善与探索推荐系统的优化方案，并依法保证您对个性化推荐的自主选择及控制权。我们将依法保护您浏览、修改、删除相关个人信息以及撤回授权的权利，并将运用加密技术、匿名化处理等其他与“雷石手机点歌平台”软件及相关服务相匹配的技术措施及其他安全措施保护您的个人信息。请您注意勿在使用本软件及服务中透露自己的各类财产账户、银行卡、信用卡、第三方支付账户及对应密码等重要资料，否则由此带来的任何损失由您自行承担。您在使用本软件及服务时不可将自认为隐私的信息发表、上传至本软件，也不可将该等信息通过本软件的服务传播给其他人，若您的行为引起的隐私泄露，由您自行承担责任和后果。我们提供服务时可能会收集您的个人信息和用户数据，用于雷石手机点歌平台各项核心功能或用以更好的向您提供服务（包括但不限于排行榜、“上墙”等）。通常个人信息包括但不限于用户昵称、性别、年龄、出生日期、兴趣爱好等；用户数据包括但不限于位置数据、音频信息、个人上网记录、喜好、歌单及常用设备信息等。国家法律法规、政策有其它规定和要求的除外。
    </p>
    <p>
      1.用户在注册账号或使用本产品的服务、访问雷石点歌台站网页、或参加任何形式的用户活动时，雷石点歌台站收集的用户的个人身份识别资料，可能包括用户的姓名、昵称、电邮地址、出生日期、性别、职业、所在行业、手机号码并设置密码、或通过您认可的第三方账号授权注册、或法律法规、规章规范性文件（以下称“法律法规”）规定的需要填写的身份信息。
    </p>
    <p>
      2.个人隐私信息是指涉及用户个人身份或个人隐私的信息，比如，用户真实姓名、身份证号、手机号码、手机设备识别码、IP地址、用户聊天记录。非个人隐私信息是指用户对本服务的操作状态以及使用习惯等明确且客观反映在雷石点歌台服务器端的基本记录信息、个人隐私信息范围外的其它普通信息，以及用户同意公开的上述隐私信息。
    </p>
    <p>
      3.雷石点歌台可能利用工具，为合作伙伴的网站进行数据搜集工作，有关数据也会作统计用途。网站会将所记录的雷石点歌台用户数据整合起来，以综合数据形式供合作伙伴参考。综合数据会包括人数统计和使用情况等资料，但不会包含任何可以识别个人身份的数据。当雷石点歌台要替合作伙伴进行数据搜集时，雷石点歌台将和合作伙伴同时在网站或者是网页上告知用户。
    </p>
    <p>
      4.雷石点歌台将采取技术措施和其他必要措施，确保用户个人隐私信息安全，防止在本软件中收集的用户个人隐私信息泄露、毁损或丢失。在发生前述情形或者雷石点歌台发现存在发生前述情形的可能时，将及时采取补救措施。
    </p>
    <p>5.雷石点歌台不会将用户的个人识别信息出租、出售或泄漏给任何人，以下情况除外：用户明确同意让第三方共享资料；只有透露用户的个人资料，才能提供用户所要求的产品和服务；为保护雷石点歌台、用户及社会公众的权利、财产或人身安全；根据法律法规的规定，向司法机关提供；受到黑客攻击导致用户信息泄漏的；被搜索引擎在搜索结果中显示；其他雷石点歌台认为有必要的情况。</p>
    <p>6.雷石点歌台未经用户同意不向任何第三方公开、透露用户个人隐私信息。但以下特定情形除外：</p>
    <p>(1)雷石点歌台根据法律法规规定或有权机关的指示提供用户的个人信息；</p>
    <p>(2)由于用户将其用户密码告知他人或与他人共享注册帐户与密码，由此导致的任何个人信息的泄漏，或其他不可抗力等非因雷石点歌台原因导致的个人隐私信息的泄露；</p>
    <p>(3)用户自行选择向第三方公开其个人信息；</p>
    <p>(4)用户与雷石点歌台及合作单位之间就用户个人信息的使用公开达成约定，雷石点歌台因此向合作单位公开用户个人隐私信息；</p>
    <p>(5)任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人隐私信息的泄露；</p>
    <p>(6)用户在使用本软件平台提供的搜索服务时输入的关键字信息；</p>
    <p>(7)本软件收集到的用户在本软件发布的有关信息数据，包括但不限于参与活动、成交信息及评价详情；</p>
    <p>(8)违反法律规定或违反本软件规则行为及本软件已对用户采取的措施；</p>
    <p>(9)本协议约定的其他情形等。</p>
    <p>7.用户同意雷石点歌台可在以下事项中使用用户的个人信息：</p>
    <p>(1)雷石点歌台向用户及时发送重要通知，如软件更新、本协议条款的变更；</p>
    <p>(2)雷石点歌台内部进行审计、数据分析和研究等，以改进雷石点歌台的产品、服务和与用户之间的沟通；</p>
    <p>(3)依本协议约定，用户公开其个人信息、雷石点歌台管理、审查用户信息及进行处理措施；</p>
    <p>(4)适用法律法规规定的其他事项。</p>
    <p>(5)提供雷石点歌台网站服务、改进网页内容，满足用户对某种产品、活动的需求、通知您最新产品、活动信息、或根据法律法规要求。</p>
    <p>(6)除上述事项外，如未取得用户同意，雷石点歌台不会将用户个人隐私信息使用于任何其他用途。</p>
    <p>8.本软件尊重并保护所有使用服务用户的个人隐私权。为了给用户提供更准确、更有个性化的服务，本软件会按照本隐私权政策的规定使用和披露用户的个人信息。本软件将以高度的勤勉、审慎义务对待这些信息。</p>
    <p>9.为服务用户的目的，本软件可能通过使用用户的个人信息，向用户提供用户感兴趣的信息，包括但不限于向用户发出产品和服务信息。</p>
    <p>10.除本隐私权政策另有规定外，在未征得用户事先许可的情况下，本软件不会将这些信息对外披露或向第三方提供。</p>
    <p>11.本软件会不时更新本隐私权政策。用户在同意本软件服务使用协议之时，即视为用户已经同意本隐私权政策全部内容。本隐私权政策属于本软件服务使用协议不可分割的一部分。</p>
    <h2 class="sub-title">
      三、用户行为规范
    </h2>
    <p>
      本软件的服务仅供个人交流、学习欣赏、非商业性质的使用，用户不可对本软件及服务任何部分的任何信息进行复制、拷贝、出售、或利用本软件及服务进行调查、广告、或用于其他商业目的。
    </p>
    <p>
      1.您应对您使用“雷石手机点歌平台”软件及相关服务的行为负责，除非法律允许或者经公司事先书面许可，您使用“雷石手机点歌平台”软件及相关服务不得具有下列行为：
    </p>
    <p>
      1.1使用未经公司授权或许可的任何插件、外挂、系统或第三方工具对“雷石手机点歌平台”软件及相关服务的正常运行进行干扰、破坏、修改或施加其他影响。；
    </p>
    <p>
      1.2利用或针对“雷石手机点歌平台”软件及相关服务进行任何危害计算机网络安全的行为，包括但不限于：
    </p>
    <p>
      （1）非法侵入网络、干扰网络正常功能、窃取网络数据等危害网络安全的活动；
    </p>
    <p>
      （2）提供专门用于从事侵入网络、干扰网络正常功能及防护措施、窃取网络数据等危害网络安全活动的程序、工具；
    </p>
    <p>
      （3）明知他人从事危害网络安全的活动的，为其提供技术支持、广告推广、支付结算等帮助；
    </p>
    <p>
      （4）使用未经许可的数据或进入未经许可的服务器/帐号；
    </p>
    <p>
      （5）未经允许进入公众计算机网络或者他人计算机系统并删除、修改、增加存储信息；
    </p>
    <p>
      （6）未经许可，企图探查、扫描、测试“雷石手机点歌平台”系统或网络的弱点或其它实施破坏网络安全的行为；
    </p>
    <p>
      （7）企图干涉、破坏“雷石手机点歌平台”系统或网站的正常运行，故意传播恶意程序或病毒以及其他破坏干扰正常网络信息服务的行为；
    </p>
    <p>
      （8）伪造TCP/IP数据包名称或部分名称；
    </p>
    <p>
      （9）对“雷石手机点歌平台”软件及相关服务进行反向工程、反向汇编、编译或者以其他方式尝试发现“雷石手机点歌平台”软件及相关服务的源代码；
    </p>
    <p>
      （10）违反法律法规、本协议、公司的相关规则及侵犯他人合法权益的其他行为。
    </p>
    <p>
      1.3如果公司有理由认为您的行为违反或可能违反上述约定的，公司可独立进行判断并处理，且在任何时候有权在不事先通知的情况下终止向您提供服务，并依法追究相关责任。
    </p>
    <p>
      您按规定完成实名认证后，可以以注册帐号或“雷石手机点歌平台”合作平台帐号登录“雷石手机点歌平台”发布信息、互动交流、评论等。您在“雷石手机点歌平台”中因相关操作所形成的歌曲评分、榜单等信息将会向其他用户展示。我们致力使发布信息、互动交流、评论成为文明、理性、友善、高质量的意见交流。在推动发布信息、互动交流、评论业务发展的同时，不断加强相应的信息安全管理能力，完善发布信息、互动交流、评论自律，切实履行社会责任，遵守国家法律法规，尊重公民合法权益，尊重社会公序良俗。您制作、评论、发布、传播的信息（包括但不限于实时互动或上传至“雷石手机点歌平台”软件的录音制品）应自觉遵守法律法规、社会主义制度、国家利益、公民合法权益、社会公共秩序、道德风尚和信息真实性等“七条底线”要求，否则我们有权立即采取相应处理措施。您同意并承诺不利用本软件及服务上传、制作、复制、发布、传播、存储含有下列内容的信息：
    </p>
    <p>
      （1）反对宪法所确定的基本原则的；
    </p>
    <p>
      （2）危害国家安全，泄露国家秘密；
    </p>
    <p>
      （3）颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的；
    </p>
    <p>
      （4）损害国家荣誉和利益的；
    </p>
    <p>
      （5）宣扬恐怖主义、极端主义的；
    </p>
    <p>
      （6）煽动民族仇恨、民族歧视，破坏民族团结的；
    </p>
    <p>
      （7）煽动地域歧视、地域仇恨的；
    </p>
    <p>
      （8）破坏国家宗教政策，宣扬邪教和封建迷信的；
    </p>
    <p>
      （9）编造、散布谣言、虚假信息，扰乱经济秩序和社会秩序、破坏社会稳定的；
    </p>
    <p>
      （10）散布、传播淫秽、色情、粗俗、猥亵、赌博、暴力、凶杀、恐怖、教唆犯罪或其它道德上令人反感的内容；
    </p>
    <p>
      （11）危害网络安全、利用网络从事危害国家安全、荣誉和利益的；
    </p>
    <p>
      （12）侮辱或者诽谤他人，侵害他人知识产权、商标权、商业秘密、肖像权、名誉权、荣誉权、名称权、姓名权、隐私权等合法的人身和财产权益；
    </p>
    <p>
      （13）对他人进行暴力恐吓、威胁，实施人肉搜索的；
    </p>
    <p>
      （14）涉及他人隐私、个人信息或资料的；
    </p>
    <p>
      （15）散布污言秽语，损害社会公序良俗的；
    </p>
    <p>
      （16）侵犯他人隐私权、名誉权、肖像权、知识产权等合法权益内容的；
    </p>
    <p>
      （17）散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息；
    </p>
    <p>
      （18）使用本软件常用语言文字以外的其他语言文字评论的；
    </p>
    <p>
      （19）与所评论的信息毫无关系的；
    </p>
    <p>
      （20）所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；
    </p>
    <p>
      （21）侵害未成年人合法权益或者损害未成年人身心健康的；
    </p>
    <p>
      （22）未获他人允许，偷拍、偷录他人，侵害他人合法权利的；
    </p>
    <p>
      （23）包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形：
    </p>
    <p>
      i.任何暴力和/或自残行为内容；
    </p>
    <p>
      ii.任何威胁生命健康、利用刀具等危险器械表演的危及自身或他人人身及/或财产权利的内容；
    </p>
    <p>
      iii.怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容；
    </p>
    <p>
      （24）将本软件以任何形式作为从事各种非法活动的场所、平台或媒介，进行其他任何违法以及侵犯其他个人、公司、社会团体、组织的合法权益的行为；
    </p>
    <p>
      （25）其他含有违反法律法规、政策及公序良俗、干扰“雷石手机点歌平台”正常运营或侵犯其他用户或第三方合法权益内容的信息。
    </p>
    <p>
      3.您承诺并保证，您在使用本软件时所上传、发布、传播的文字、图片、语音、音乐作品、音频资料或任何其他内容拥有相应合法的权利，上述文字、图片、语音、音乐作品、音频资料或任何其他内容不侵犯任何第三方的肖像权、名誉权、知识产权等权利或利益，一旦上传、发布、传播即视为您已经依法取得相关权利且有权并同意授予我们信息网络传播权，您就所上传、发布、传播的内容独立承担全部法律责任。您同意我们有权对您上传、发布的信息依法或依据本协议进行删除或屏蔽，或在收到侵权投诉通知后删除此类信息。
    </p>
    <p>
      4.您不得利用本软件上传、发布、传播违法信息、虚假信息、广告信息、垃圾信息、骚扰信息，或者进行任何非法的侵害雷石手机点歌平台和其他第三方合法权益的行为。因您违反法律规定或本协议规定造成违约或侵犯第三方合法权益的，
由您自行解决及承担全部法律责任。如果给我们造成损失，我们有权向您追偿因此所遭受的全部损失。
    </p>
    <p>
      5.如果您上传、发布或传输的内容含有以上违反法律法规的信息或内容的，或者侵犯任何第三方的合法权益，您将直接承担以上导致的一切不利后果。如因此给雷石点歌造成不利后果的，您应负责消除影响，并且赔偿雷石点歌因此导致的一切损失，包括且不限于财产损害赔偿、名誉损害赔偿、律师费、交通费等因维权而产生的合理费用。
    </p>
    <p>
      6.您理解并保证不就雷石点歌台服务进行下列禁止的行为，也不允许任何人利用您的账户进行下列行为：
    </p>
    <p>
      （1）在注册账户时，或使用雷石点歌平台服务（包括但不限于上传、发布、传播信息等）时，冒充他人或机构，或您讹称与任何人或实体有联系（包括设置失实的账户名称或接入另一用户的账户），或您恶意使用注册账户导致其他用户误认；
    </p>
    <p>
      （2）伪造标题或以其他方式操控内容，使他人误认为该内容为雷石点歌所传输；
    </p>
    <p>
      （3）将无权传输的内容（例如内部资料、机密资料、侵犯任何人的专利、商标、著作权、商业秘密或其他专属权利之内容等）进行上传、发布、发送电子邮件或以其他方式传输；</p>
    <p>
      （4）上传、张贴、发送电子邮件或以其他方式传送任何未获邀约或未经授权的“垃圾电邮”、广告或宣传资料、促销资料，或任何其他商业通讯；</p>
    <p>
      （5）未经雷石点歌明确许可，使用雷石点歌平台服务用于任何商业用途或为任何第三方的利益；
    </p>
    <p>
      （6）冒充任何人或机构，包含但不限于冒充雷石点歌台工作人员、版主、主持人，或以虚伪不实的方式陈述或谎称与任何人或机构有关的。
    </p>
    <p>
      （7）将侵犯任何人的肖像权、名誉权、隐私权、专利权、商标权、著作权、商业秘密或其它专属权利的内容上载、张贴、发送电子邮件或以其它方式传送的。
    </p>
    <p>
      （8）将病毒或其它计算机代码、档案和程序，加以上载、张贴、发送电子邮件或以其它方式传送的。
    </p>
    <p>
      （9）在注册时公布虚假的、不完整的或不准确的简历资料。或公布不以征友为目的的信息的，如意见、通知、商业广告或其他内容。
    </p>
    <p>
      （10）擅自删除或修改任何其他个人公布的资料。擅自打印、复制或使用有关注册会员的任何个人资料。未经公布信息者本人同意，给公布信息的个人发电子邮件、打电话、寄信或进行其他任何形式的接触。
    </p>
    <p>
      （11）未经合法授权而截获、篡改、收集、储存或删除他人个人信息、电子邮件或其它数据资料，或将获知的此类资料用于任何非法或不正当目的。
    </p>
    <p>
      （12）本软件的竞争同行或者是其他不相关人员以参加本软件会员活动的形式取得、参考、模仿本软件会员活动的任何信息、资料。
    </p>
    <p>
      （13）本公司的竞争同行用此方法寻求与本软件注册会员的联系或者使用本软件注册会员的任何资料用于任何用途。本公司的竞争同行用此方法参考、复制、模仿、仿制、篡改本软件发布、策划、组织的任何活动（包括但不限于活动主题、创意、形式等一系列内容）。
    </p>
    <p>
      （14）在任何情况下，如果雷石点歌台有理由认为用户的任何行为，包括但不限于用户的任何言论和其它行为违反或可能违反上述规定和法律的规定，雷石点歌台可在任何时候不经任何事先通知终止向该用户提供服务。
    </p>
    <p>
      （15）跟踪或以其他方式骚扰他人；
    </p>
    <p>
      （16）参与任何非法或有可能非法（由雷石点歌判断）的活动或交易，包括传授犯罪方法、出售任何非法药物、洗钱活动、诈骗等；
    </p>
    <p>
      （17）赌博、提供赌博数据或透过任何方法诱使他人参与赌博活动；
    </p>
    <p>
      （18）使用或利用雷石点歌知识产权（包括雷石点歌的商标、品牌、标志、任何其他专有数据或任何网页的布局或设计），或在其他方面侵犯雷石点歌任何知识产权（包括试图对雷石点歌平台客户端或所使用的软件进行逆向工程）；
    </p>
    <p>
      （19）通过使用任何自动化程序、软件、引擎、网络爬虫、网页分析工具、数据挖掘工具或类似工具，接入雷石点歌平台服务、收集或处理通过雷石点歌平台服务所提供的内容；
    </p>
    <p>
      （20）参与任何“框架”、“镜像”或其他技术，目的是模仿雷石点歌平台服务的外观和功能；
    </p>
    <p>
      （21）干预或试图干预任何用户或任何其他方接入雷石点歌平台服务；
    </p>
    <p>
      （22）故意散播含有干扰、破坏或限制计算机软件、硬件或通讯设备功能、雷石点歌平台服务、与雷石点歌平台服务相连的服务器和网络的病毒、网络蠕虫、
特洛伊木马病毒、已损毁的档案或其他恶意代码或项目等资料；
    </p>
    <p>
      （23）未经他人明确同意，分享或发布该等人士可识别个人身份的资料；
    </p>
    <p>
      （24）探究或测试雷石点歌平台服务、系统或其他用户的系统是否容易入侵攻击，或在其他方面规避（或试图规避）雷石点歌平台服务、系统或其他用户的系统的任何安全功能；
    </p>
    <p>
      （25）对雷石点歌平台服务所用的软件进行解编、反向编译或逆向工程，或试图作出上述事项；
    </p>
    <p>
      （26）为破坏或滥用的目的开设多个账户，或恶意上传重复的、无效的大容量数据和信息；
    </p>
    <p>
      （27）进行任何破坏雷石点歌平台服公平性或者其他影响应用正常秩序的行为，如主动或被动刷分、合伙作弊、使用外挂或者其他的作弊软件、利用BUG（又叫“漏洞”或者“缺陷”）来获得不正当的非法利益，或者利用互联网或其他方式将外挂、作弊软件、BUG公之于众；
    </p>
    <p>
      （28）进行任何诸如发布广告、销售商品的商业行为，或者进行任何非法的侵害雷石点歌平台利益的行为，如贩卖雷石点歌平台平台鱼丸鱼翅等虚拟产品、外挂等；
    </p>
    <p>
      （29）通过任何渠道或媒体（包括但不限于自媒体等）发出“与雷石点歌合作”、“与雷石点歌共同出品”等任何携带“雷石点歌”品牌的字样，如您宣传推广合作节目，您只能在宣传中提及节目本身而不得提及与雷石点歌关系或者擅自以雷石点歌品牌进行推广，凡是您的发稿带有“雷石点歌”的一切宣传稿件必须通过雷石点歌相应合作部门之书面同意，否则因此给雷石点歌造成的一切损失您应予以赔偿；您应遵守本协议的各项条款，正确、适当地使用本服务，不得扰乱雷石点歌平台秩序。同时，雷石点歌保留在任何时候收回该帐号、用户名的权利。严重者雷石点歌有权对中止或终止您使用雷石点歌全部或部分服务、注销账户以及依据法律法规保存有关信息并向有关部门报告等。
    </p>
    <p>7.雷石手机点歌平台有权根据运营需要，发布各项规则。您在使用雷石手机点歌平台的产品和服务的过程中，还需遵守雷石手机点歌平台发布的各项规则。</p>
    <h2 class="sub-title">
      四、费用支付
    </h2>
    <p>
      1.本软件所提供部分服务或应用可能涉及付费，您输入账号、密码的行为视为对收费服务的接受，您一旦接受收费服务，需要按雷石手机点歌平台公示的收费标准支付费用。
    </p>
    <p>
      2.您知悉并理解，会员增值服务系网络虚拟服务，会员费用是您所购买的会员服务所对应的价格，而非预付款或者存款、定金、储蓄卡等性质。会员增值服务一经开通后不可退款(但因法律规定、会员增值服务存在重大瑕疵导致您完全无法使用或雷石公司同意退款除外)。
    </p>
    <p>
      3.您享受的付费服务也可能需要周期性、多次性付费，每项付费服务到期前，您若需要取消该项服务，应向雷石手机点歌平台提出；若您没有及时提出，视为同意对该项收费服务自动续费。
    </p>
    <p>
      4.您付费后获得的权益不得转让给第三人。
    </p>
    <p>
      5.您在雷石手机点歌平台可以选择使用您的第三方支付账户及绑定银行卡进行支付、提现等平台服务，您理解并确认，该支付服务由具备合法资质的第三方向用户提供，除了受到本协议的约束之外，还要受第三方支付服务方及金融机构的条款和政策的约束。如果您需要使用雷石手机点歌平台支付相关服务（零钱、收发红包、添加银行卡、收付款等支付服务）时，需阅读并遵守雷石手机点歌平台支付运营主体北京雷石天地电子技术股份有限公司的相关服务协议。该等支付服务的使用条件及规范由您与支付服务提供方确定，我们不对该支付服务或金融机构承担任何责任。如您在雷石手机点歌平台中使用第三方金融服务，包括但不限于支付、提现、保险、借贷等，请认真了解该服务的内容，充分阅读并同意相关协议条款。
    </p>
    <p>
      6.您充分理解并同意，您在雷石手机点歌台软件上进行的任何交易行为及可能引起的风险，均由您自行承担。您在账户中进行任何交易行为时都应当充分阅读并理解相关交易规则，您进行的任何操作行为都将视为您已经充分阅读并同意相应的交易规则。如果由于您误操作、账户泄露而导致任何损失，您需要自行承担，我们将不承担任何责任。
    </p>
    <h2 class="sub-title">
      五、雷石声明
    </h2>
    <p>
      1.您理解并同意，“雷石手机点歌平台”软件及相关服务可能会受多种因素的影响或干扰，公司不保证(包括但不限于)：
    </p>
    <p>
      1.1“雷石手机点歌平台”软件及相关服务完全适合用户的使用要求；
    </p>
    <p>
      1.2“雷石手机点歌平台”软件及相关服务不受干扰，及时、安全、可靠或不出现错误；用户经由公司取得的任何软件、服务或其他材料符合用户的期望；
    </p>
    <p>
      1.3“雷石手机点歌平台”软件及相关服务中任何错误都将能得到更正。
    </p>
    <p>
      2.您理解并同意，我们对您利用雷石手机点歌平台软件传播的明确的或隐含的信息之真实性、适当性、适用性、所有权和非侵权性等不作担保，您使用本软件及服务可能接收到来自任何其他人的包括威胁性的、诽谤性的、令人反感的、非法的信息，由此导致的直接、间接、偶然、特殊及后续的损害风险由您自行承担，我们不承担任何责任。在任何情况下，雷石点歌台均不为用户经由网站服务以张贴、发送电子邮件或其它方式传播的任何内容负责。
    </p>
    <p>
      3.您理解并同意，我们或第三方可能通过本软件不时发布广告或其它商业信息，您在接触这些广告时需自行判断，并自行承担使用前述信息带来的风险。对加载在本软件上的其他公司的产品，以及使用这些产品所呈现的信息的真实性、准确性、知识产权，我们不承担责任。如有涉嫌借款、投融资、理财或其他涉财产的网络信息、账户密码、广告或推广等信息的，请您谨慎对待并自行进行判断，对您因此遭受的利润、商业信誉、资料损失或其他有形或无形损失，我们不承担任何直接、间接、附带、特别、衍生性或惩罚性的赔偿责任。我们依照法律规定履行广告及推广相关义务，您应当自行判断该广告或推广信息的真实性和可靠性并为自己的判断行为负责。除法律法规明确规定外，您因该广告或推广信息进行的购买、交易或因前述内容遭受的损害或损失，您应自行承担，公司不予承担责任。
    </p>
    <p>
      4.您理解并同意，在您使用“雷石手机点歌平台”软件及相关服务过程中，公司可能会向您推送具有相关性的信息、广告发布或品牌推广服务，且我们将在“雷石手机点歌平台”软件及相关服务中展示“雷石手机点歌平台”软件及相关服务和/或第三方供应商、合作伙伴的商业广告、推广或信息（包括商业或非商业信息）。
    </p>
    <p>
      5.您能理解，本软件及服务同大多数因特网产品一样，易受到各种安全问题的困扰，包括但不限于：透露详细个人资料、被不法分子利用，造成现实生活中的骚扰；被哄骗、破译用户密码；用户下载安装的其它软件中含有“特洛伊木马”等病毒，威胁到个人终端设备上的信息和数据安全，继而威胁对本软件及服务的使用。同时，互联网技术的不稳定性，可能导致政府政策管制、病毒入侵、黑客攻击、服务器系统崩溃或者其他现今技术无法解决的风险，可能导致雷石手机点歌平台服务中断、用户账号道具损失及其它损失。对于发生上述情况及非人
为因素引起损失的，您应当自行承担责任。
    </p>
    <p>
      6.您理解并同意，在使用“雷石手机点歌平台”软件及相关服务过程中，可能遇到不可抗力等因素（不可抗力是指不能预见、不能克服并不能避免的客观事件），包括但不限于政府行为、自然灾害（如洪水、地震、台风等）、网络原因、战争、罢工、骚乱等。出现不可抗力情况时，公司将努力在第一时间及时修复，但因不可抗力造成的暂停、中止、终止服务或造成的任何损失，我们在法律法规允许范围内免于承担责任。
    </p>
    <p>
      7.您理解并同意，我们基于实际情况或服务整体运营的需要，有权在公告通知后修改、中断、中止或终止本软件及服务而不需特别单独通知您，且无须向您或第三方承担任何责任。如果您停止使用本软件及服务或服务被终止、取消，我们可以从服务器上永久地删除您的数据。服务停止、终止或取消后，我们没有义务向您返还任何数据。
    </p>
    <p>
      8.您理解并同意：关于“雷石手机点歌平台”软件及相关服务，公司不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。您对“雷石手机点歌平台”软件及相关服务的使用行为应自行承担相应风险。用户以自己的独立判断从事与交友相关的行为，并独立承担可能产生的不利后果和责任，雷石点歌台不对用户行为承担任何法律责任。
    </p>
    <p>
      9.是否使用网站服务下载或取得任何资料应由用户自行考虑并自负风险，因任何资料的下载而导致的用户电脑系统的任何损坏或数据丢失等后果，雷石点歌台不承担任何责任。
    </p>
    <p>
      10.雷石点歌台对所有用户自发组织的活动、自发成立的组织不承担任何责任。
    </p>
    <p>
      11.雷石点歌台对于本软件策划、发起、组织或是承办的任何用户活动（包括但不限于收取费用以及完全公益的活动）不担保一定能满足用户的需要，也不担保用户参加活动的结果。用户应当自行判断，并自行承担参与前述活动带来的风险。
    </p>
    <p>
      12.对于用户的投诉，雷石点歌台将认真核实，但不保证最终公之于众的投诉的真实性、合法性。投诉人应当对投诉书及提供的材料、证据等的真实性、合法性、有效性负责，如果投诉不实，或给我们或者实际权利人造成损失的，投诉内容侵犯用户隐私权、名誉权等合法权利的，则需承担相应的法律责任。
    </p>
    <p>
      13.我们依据本协议约定获得处理违法违规内容的权利，该权利不构成我们的义务或承诺，我们不能保证及时发现违法行为或进行相应处理，用户仍有可能收到各类的广告信息（雷石点歌台发送的广告信息除外）或其他邮件。
    </p>
    <p>
      14.您理解并同意，本协议旨在保障遵守国家法律法规、维护公序良俗，保护用户和他人合法权益，我们在能力范围内尽最大的努力按照相关法律法规进行判断，但并不保证我们的判断完全与司法机关、行政机关的判断一致，如因此产生的后果您已经理解并同意自行承担。
    </p>
    <p>
      15.在任何情况下，我们均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用“雷石手机点歌平台”软件及相关服务而遭受的利润损失，承担责任。除法律法规另有明确规定外，公司对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您因使用“雷石手机点歌平台”软件及相关服务期间而支付给公司的费用（如有）。
    </p>
    <h2 class="sub-title">
      六、版权声明
    </h2>
    <p>
      1.我们是本软件的知识产权权利人。本软件的著作权、商标权、专利权、商业秘密等知识产权，以及我们在“雷石手机点歌平台”软件及相关服务中提供的内容（包括但不限于软件、技术、程序、网页、文字、图片、图像、音频、视频、图表、版面设计、歌单、电子文档等）的知识产权属于我们所有，受中华人民共和国法律法规和相应的国际条约保护，我们提供“雷石手机点歌平台”及相关服务时所依托的软件的著作权、专利权及其他知识产权均归我们所有。未经我们书面许可，任何人不得擅自使用（包括但不限于通过任何机器人、“蜘蛛”等程序或设备监视、复制、传播、展示、镜像、上载、下载）“雷石手机点歌平台”软件及相关服务中的内容。但其他相关权利人依照法律规定应享有的权利除外。
    </p>
    <p>
      2.请勿擅自复制或采用雷石点歌台所创造的用以制成网页的HTML。雷石点歌台对其HTML享有著作权。同时，雷石点歌台对其网址上的所有图标、图饰、图表、色彩、文字表述及其组合、版面设计、数据库均享有完全的著作权，对发布的信息均享有专有的发布和使用权，未经雷石点歌台同意，不得擅自复制、使用或转载。
    </p>
    <p>
      3.本软件使用了第三方的软件或技术（如有），这种使用已经获得合法授权。我们按照相关法规或约定，对相关的授权协议或其他文件，通过本协议附件
进行展示。前述的授权协议或其他文件均是本协议不可分割的组成部分，与本协议具有同等的法律效力，您应当遵守这些要求。如果您没有遵守这些要求，该第三方或者国家机关可能会对您提起诉讼、罚款或采取其他制裁措施，并要求我们给予协助，您应当自行承担法律责任。如因本软件使用的第三方软件或技术引发的任何纠纷，应由该第三方负责解决，我们不对此承担责任。我们不对第三方软件或技术提供客服支持，若您需要获取支持，请与第三方联系。
    </p>
    <p>
      4.您理解并承诺，您在使用“雷石手机点歌平台”软件及相关服务时发布上传的内容（包括但不限于文字、图片、视频、音频等各种形式的内容及其中包含的音乐、声音、台词、视觉设计等所有组成部分）均由您原创或已获合法授权（且含转授权）。您通过“雷石手机点歌平台”上传、发布所产生内容的知识产权归属您或原始著作权人所有。因您进行上述内容在本网站的上传或发布，而导致任何第三方提出索赔要求或衍生的任何损害或损失，由您承担全部责任。
    </p>
    <p>
      5.除非有相反证明，您知悉、理解并同意，为使您的作品得到更好的分享及推广，提高其传播价值及影响力，您通过“雷石手机点歌平台”软件及相关服务上传、发布或传输的内容（包括但不限文字，图像，音频，视频、直播内容等各种形式的内容及其中包括的音乐、声音、台词、视觉设计、对话等所有组成部分），您授予我们及关联方、控制公司、继承公司一项全球范围内、免费、非独家、可再许可（通过多层次）的权利（包括但不限于复制权、翻译权、汇编权、信息网络传播权、改编权及制作衍生品、表演和展示的权利等），上述权利的使用范围包括但不限于在当前或其他网站、应用程序、产品或终端设备等使用。您在此确认并同意，我们有权自行或许可第三方在与上述内容、“雷石手机点歌平台”软件及相关服务、公司和/或公司品牌有关的任何宣传、推广、广告、营销和/或研究中使用和以其他方式开发内容（全部或部分）。为避免疑义，您理解并同意，上述授予的权利包括使用、复制和展示您拥有或被许可使用并植入内容中的个人形象、肖像、姓名、商标、服务标志、品牌、名称、标识和公司标记（如有）以及任何其他品牌、营销或推广资产、物料、素材等的权利和许可。基于部分功能的特性，您通过“雷石手机点歌平台”软件及相关服务发布的内容（包括但不限于内容中包含的声音、音频或对话等）可供其他用户使用“雷石手机点歌平台”软件创作及发布相关内容时使用。
    </p>
    <p>
      6.您确认并同意授权我们以我们自己的名义或委托专业第三方对侵犯您上传发布的享有知识产权的内容进行代维权，维权形式包括但不限于：监测侵权行为、发送维权函、提起诉讼或仲裁、调解、和解等，公司有权对维权事宜做出决策并独立实施。
    </p>
    <p>
      7.我们为“雷石手机点歌平台”开发、运营提供技术支持，并对“雷石手机点歌平台”软件及相关服务的开发和运营等过程中产生的所有数据和信息等享有法律法规允许范围内的全部权利。
    </p>
    <p>
      8.请您在任何情况下都不要私自使用公司的包括但不限于“雷石手机点歌平台”在内的任何商标、服务标记、商号、域名、网站名称或其他显著品牌特征等（以下统称为“标识”）。未经公司事先书面同意，您不得将本条款前述标识以单独或结合任何方式展示、使用或申请注册商标、进行域名注册等，也不得实施向他人明示或暗示有权展示、使用、或其他有权处理该些标识的行为。由于您违反本协议使用公司上述商标、标识等给公司或他人造成损失的，由您承担全部法律责任。
    </p>
    <p>
      9.为避免歧义，雷石点歌平台提醒您：我们为您提供的点播功能仅限歌曲名称列表、常点歌曲列表、置顶歌曲、会员特效等特权服务及增值服务，所点歌曲由您所在卡拉OK商户提供，如您对歌曲版权等问题有疑问，请您联系卡拉OK商户咨询和处理。
    </p>
    <h2 class="sub-title">
      七、通知和联系方式
    </h2>
    <p>
      1.本协议项下我们对于用户所有的通知均可通过网页公告、站内信、电子邮件、手机短信或常规的信件传送等方式进行，该等通知于发送之日视为已送达您。
    </p>
    <p>
      2.如您对本协议或使用我们的产品与/或服务相关的事宜有任何问题（包括问题咨询、投诉等），我们专门为您提供了多种反馈通道，希望为您提供满意的解决方案：
    </p>
    <p>
      2.1在线客服/其他在线意见反馈通道：您可与我们平台上产品功能页面的在线客服联系或者在线提交意见反馈；
    </p>
    <p>
      2.2人工客服通道：您可以拨打我们的客服电话与我们联系；
    </p>
    <p>
      2.3如您在我们平台发现涉及侵权您的权利的内容，投诉邮箱：【lvchen@thunder.com.cn】您可以通过该邮箱与我们联系，并提供相应的权属证据供我们核实。
    </p>
    <p>
      2.4其他方式：我们提供的其他反馈通道。
    </p>
    <p>
      我们会在收到您的反馈后尽快向您答复。
    </p>
    <h2 class="sub-title">
      八、其他
    </h2>
    <p>
      1.本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国法律。倘若本协议之任何规定因与中华人民共和国法律抵触而无效，则这些条款应在不违反法律的前提下按照尽可能接近本协议原条文目的之原则进行重新解释和适用，且本协议其它规定仍应具有完整的效力及效果。
    </p>
    <p>
      2.本协议的签署地点为中华人民共和国北京市朝阳区，若您与公司发生任何争议，双方应尽量友好协商解决，协商不成，您同意应将争议提交至北京市朝阳区人民法院诉讼解决。
    </p>
    <p>
      3.为给您提供更好的服务或因国家法律法规、政策调整、技术条件、产品功能等变化需要，我们会适时对本协议进行修订，修订内容构成本协议的组成部分。本协议更新后，我们会在“雷石手机点歌平台”发出更新版本，并在更新后的条款生效前通过官方网站（http://www.thunder.com.cn/）公告或其他适当的方式提醒您更新的内容，以便您及时了解本协议的最新版本，您也可以在网站首页或软件设置页面查阅最新版本的协议条款。如您继续使用“雷石手机点歌平台”软件及相关服务，即表示您已同意接受修订后的本协议内容。如您对修订后的协议内容存有异议的，请立即停止登录或使用“雷石手机点歌平台”软件及相关服务。若您继续登录或使用“雷石手机点歌平台”软件及相关服务，即视为您认可并接受修订后的协议内容。
    </p>
    <p>
      4.本协议中的标题仅为方便阅读而设，并不影响本协议中任何规定的含义或解释。
    </p>
    <p>
      5.您和公司均是独立的主体，在任何情况下本协议不构成公司对您的任何形式的明示或暗示担保或条件，双方之间亦不构成代理、合伙、合营或雇佣关系。
    </p>
      </div>
      <img class="close" @click.self="close" src="https://qncweb-back1.ktvsky.com/20220825/other/4edaf38b66c5b1c7dfaa7217ec9653a3.png" />
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit('closeAgree');
    },
  },
  mounted() {
    this.$sendLog({
      event_type: 'show',
      event_name: '用户协议展示',
      event_data: {
        name: '弹窗',
      },
    });
  }
};
</script>
<style lang="scss" scoped>
.agree-wrapper {
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  z-index: 2000;
  .agree {
    width: 630px;
    padding: 30px 40px 50px;
    background: #fff;
    height: 960px;
    border-radius: 15px;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .title {
    font-size: 40px;
    text-align: center;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 700;
    color: rgba(51, 51, 51, 1);
  }
  .close {
    width: 54px;
    position: absolute;
    right: -10px;
    top: -70px;
  }
  .content {
    margin-top: 22px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    flex: 1;
    overflow: scroll;
    p {
      text-indent: 2em;
    }
    .content-title {
      text-indent: 0em;
    }
    .sub-title {
      text-indent: 0em;
      font-size: 34px;
      font-weight: bold;
    }
  }
}
</style>
